<template>
  <div :class="$style.page">
    <div :class="$style.headerWrapper">
      <div :class="$style.header">
        <div :class="$style.headerContent">
          <img :class="$style.logo" :src="logoResearch">
          <h2 :class="$style.title">数字经济观察和数字人才培养</h2>
          <div :class="$style.subtitle">通过在数字经济方面的观察以及在数字人才发展与培养方面的研究，以期帮助企业更好地走上自己的数字化转型之路。</div>
        </div>
        <img :class="$style.rencai" :src="rencaiImg">
      </div>
    </div>
    <div :class="$style.main">
      <div :class="$style.numberIntroWrapper">
        <div :class="$style.numberIntro">
          <p>“双数”研究院是极客邦科技的核心研究机构，“双数”指研究院的主要研究方向：数字经济观察和数字人才培养。双数研究院的核心职能包括：数字经济观察、数字化人才培养研究与体系设计、数字化转型企业架构方法论研究与微咨询、数字经济研究、生态建设相关研究与实践，以及数字化转型案例发掘与推广。</p>
          <p>下设 InfoQ 研究中心，秉承客观、深度的内容原则，追求研究扎实、观点鲜明、生态互动的目标，聚焦创新技术与科技行业，围绕数字经济观察、数字人才发展进行研究。InfoQ 研究中心主要聚焦在前沿科技领域、数字化产业应用和数字人才三方面，旨在加速创新技术的孵化、落地与传播，服务相关产业与更广阔的市场、投资机构， C-level 人士、架构师 / 高阶工程师等行业观察者，为全行业架设沟通与理解的桥梁，跨越从认知到决策的信息鸿沟。</p>
        </div>
      </div>
      <div :class="[$style.container, $style.direction]">
        <h3 :class="$style.moduleTitle">双数研究院三大重点工作方向</h3>
        <Direction />
      </div>
      <div :class="$style.cert">
        <div :class="$style.container">
          <h3 :class="[$style.moduleTitle,$style.modulHeader]">创新实践</h3>
          <Certs />
        </div>
      </div>
      <div :class="$style.harvest">
        <div :class="$style.container">
          <h3 :class="$style.moduleTitle">研究成果</h3>
          <Harvest />
        </div>
      </div>
      <!-- <div :class="$style.team">
        <div :class="$style.container">
          <h3 :class="$style.moduleTitle">院长简介</h3>
          <Team />
        </div>
      </div> -->
      <div :class="$style.expert">
        <div :class="$style.container">
          <h3 :class="$style.moduleTitle">特聘专家</h3>
          <div :class="$style.subtitle">以下按专家名字首字母排序，不分先后</div>
          <Expert />
        </div>
      </div>
      <div :class="$style.cooperation">
        <div :class="$style.container">
          <h3 :class="$style.moduleTitle">合作机构</h3>
          <Cooperation />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import logoResearch from '@/assets/img/logo/research-institute.png'
import bgHeaderImg from '@/assets/img/number/bg-header.png'
import rencaiImg from '@/assets/img/number/rencai.png'

import Direction from './PcDirection.vue'
import Certs from './PcCerts.vue'
import Harvest from './PcHarvest.vue'
// import Team from './PcTeam.vue'
import Expert from './PcExpert.vue'
import Cooperation from './PcCooperation.vue'

export default {
  name: '',
  components: {
    Direction,
    Certs,
    Harvest,
    // Team,
    Expert,
    Cooperation
  },
  data () {
    return {
      logoResearch,
      bgHeaderImg,
      rencaiImg
    }
  },
  computed: {
  },
  created () {
  },
  mounted () {
  },
  watch: {
  },
  methods: {}
}
</script>

<style lang="scss" module>
.page {
}

.container {
  padding: 60px 0;
  width: 1200px;
  margin: 0 auto;

  .moduleTitle {
    margin: 0;
    text-align: center;
    font-size: 32px;
    font-weight: 500;
    color: #333333;
    line-height: 45px;
  }
  .modulHeader {
    margin-top: -60px;
  }

  .subtitle {
    margin-top: 8px;
    text-align: center;
    font-size: 18px;
    color: #888;
    line-height: 24px;
  }
}

.headerWrapper {
  height: 460px;
  background: url(../../assets/img/number/bg-header.png) no-repeat center;
}

.header {
  position: relative;
  display: flex;
  margin: 0 auto;
  padding-top: 90px;
  width: 1200px;

  .rencai {
    position: absolute;
    top: 60px;
    right: -10px;
    height: 390px;
  }

  .headerContent {
    width: 500px;
  }

  .logo {
    height: 78px;
  }

  .title {
    margin-top: 21px;
    margin-bottom: 8px;
    font-size: 36px;
    font-weight: 600;
    color: #404040;
    line-height: 42px;
  }

  .subtitle {
    margin-top: 27px;
    font-size: 15px;
    color: #404040;
    line-height: 26px;
  }
}

.numberIntroWrapper {
  height: 220px;
}

.numberIntro {
  box-sizing: border-box;
  position: relative;
  top: -60px;
  margin: 0 auto;
  padding: 48px 48px 0 48px;
  width: 1200px;
  height: 280px;
  background: url(../../assets/img/number/bg-box.png) no-repeat top 0 left 0 / 290px 192px, #fff;
  box-shadow: 0px 2px 20px 0px rgba(151,151,194,0.13), inset 2px 2px 0px 0px #FFFFFF;
  border-radius: 12px;

  p {
    font-size: 15px;
    font-weight: 400;
    color: #404040;
    line-height: 28px;

    &:last-child {
      margin-top: 16px;
    }
  }
}

.direction {
  position: relative;
  height: 652px;
  background: url(../../assets/img/number/annular.png) no-repeat top 169px left 50% / 276px 232px;

  // &::after {
  //   content: '';
  //   position: absolute;
  //   bottom: 0;
  //   left: 0;
  //   right: 0;
  //   top: 625px;
  //   height: 1px;
  //   background: linear-gradient(270deg, #FFFFFF 0%, #EAEAEA 16%, #DCDCDC 83%, #FFFFFF 100%);
  // }
}

.harvest {
  background: #F0F4F8;
}

.cooperation {
  background: #F0F4F8;
}
</style>
